import { useGimbalControl } from "providers/GimbalControlProvider";

import FunctionalButton from "components/layout/FunctionalButton";
import { ReactComponent as CenterIcon } from "assets/svgs/GimbalCenter.svg";

const CenterGimbalButton = ({ className = "" }) => {
    const { sendGimbalCenter } = useGimbalControl();

    const handleCenter = async () => {
        try {
            await sendGimbalCenter();
        } catch (error) {
            console.error("Failed to center gimbal:", error);
        }
    };

    return (
        <FunctionalButton
            className={`control-button-type3 ${className}`}
            aria-label="Center"
            icon={<CenterIcon className="text-white" />}
            onClick={handleCenter}
        />
    );
};

export default CenterGimbalButton;
